import { type NavItem } from './navTree'

export function accessibleLabel(item: NavItem): string {
  return item.badge && item.badge.count > 0 ? `${item.label}, ${item.badge.count}` : item.label
}
